import React, { useState } from "react";
import styles from "./PWAHeader.module.scss";
import HomeIcon from "@/components/Logos/Home";
import ImpactIcon from "@/components/Logos/Impact";
import DesignerIcon from "@/components/Logos/Designer";
import ShopIcon from "@/components/Logos/Shop";
import { useDispatch, useSelector } from "react-redux";
import { isMenuVisible, setSearchIcon, lowerHeaderZIndex } from "@/redux/actions/headerAction";
import { useRouter } from "next/compat/router";
import { useEffect } from "react";
import AccountIcon from "@/components/Logos/Account";
import { isGuest, previousNavSelect, showPwaLoader } from "@/redux/actions/pwaAction";
import { openAccountSidebar, openAccountSidebarFromPwaHeader } from "@/redux/actions/loggedInUser";
import { isPWA } from "@/helpers/generalHelper";
import ShopAndSearch from "@/components/Logos/ShopAndSearch";
import { openWishlistSidebar } from "@/redux/actions/wishlistAction";
import { openMiniCart, openEngraveSidebar } from "@/redux/actions/addToCartAction";
import { deleteCookie, getCookie } from "cookies-next";
import { closeOliPopup } from "@/redux/actions/oliCategoryAction";

//OS-3905: Navigation bar for PWA
const PWAHeader = ({ handleMobileAccountBar }) => {
  const visited = useSelector((state) => state.pwa.is_visited);
  const previous_nav = useSelector((state) => state.pwa.previous_nav);
  let activeState = localStorage.getItem('selectedIcon') ? localStorage.getItem('selectedIcon') :'/';
  const wc_journey_step = useSelector((state) => state.pwa.welcome_journey.currentStepNo);
  const [activeIcon, setActiveIcon] = useState(activeState);
  const dispatch = useDispatch();
  const router = useRouter();
  useEffect(() => {
    if (router.asPath === '/' && router.asPath != activeState) {
      setActiveIcon('/');
    }
  }, [router.asPath]);
  const checkPwa = isPWA();
  const menuOpen = useSelector((state) => state.header.isMenuVisible);
  const wishlistSidebarOpen = useSelector(
    (state) => state.wishlist.open_wishlist_sidebar
  );
  const basketSidebarOpen = useSelector((state) => state.click.open_mini_cart);
  const engraveSidebarOpen = useSelector((state) => state.click.open_engrave_sidebar);
  const userLoggedIn = useSelector((state) => state.loginUser.userLoggedIn);
  const accountSidebarOpen = useSelector(
    (state) => state.loginUser.open_account_sidebar
  );

  // Set the selected icon in localStorage
  const setSelectedIcon = (base) => {
    localStorage.setItem('selectedIcon', base);
  };

  // Updated isActive function to check against localStorage
  const isActive = (base) => {
    if(activeIcon == base) {
      return true;
    }
    // if (router.asPath === base && router.asPath.includes(base)) {
    //   setSelectedIcon(base); // Set the selected icon base path in localStorage
    //   return true;
    // }
    // else {
    //   // For other paths, check if currentPath starts with the base and is followed by a '/'
    //   // This prevents partial matches like '/impact' being true for '/'
    //   const currentPath = localStorage.getItem('selectedIcon');
    //   return currentPath?.startsWith(`${base}/`) || currentPath === base;
    // }
  };

  // Update the handleRoute function to set the selected icon in localStorage
  const handleRoute = (route) => {
    dispatch(previousNavSelect(activeIcon));
    setActiveIcon(route)
    setSelectedIcon(route); // Set the selected icon base path in localStorage
    //  to prevent overloapping of search and other menus
    dispatch(setSearchIcon(false))
    if(route == '/' || route == "/impact" || route == "/designer") {
      dispatch(isMenuVisible(false));
      handleMobileAccountBar(false);
      // if user clicks on wishlist or bag icon, then clicks on home
      dispatch(openWishlistSidebar(false));
      dispatch(openMiniCart(false))
    } 
    else if(route == '/shop') {
      handleMobileAccountBar(false);
      dispatch(isMenuVisible(true));
      // if user clicks on wishlist or bag icon, then clicks on shop
      dispatch(openWishlistSidebar(false));
      dispatch(openMiniCart(false))
    }
    else if(route == '/account') {
      dispatch(openWishlistSidebar(false));
      dispatch(openMiniCart(false))
    }
    //delete cookie while shifting tabs which was added to re open account sidebar for OS-4181
    if(route !== "/account" && getCookie("account_reopen")) {
      deleteCookie("account_reopen");
    }
    if (router.asPath === route) return;
  };

  const setZindex = (ele) => {
    if (ele) {
      if (ele.style.paddingLeft !== 0) ele.style.paddingLeft = 0;
      if (menuOpen || wishlistSidebarOpen || basketSidebarOpen || accountSidebarOpen || engraveSidebarOpen ) {ele.style.zIndex = 99;}
      else {setTimeout(() => (ele.style.zIndex = 101), 300);}
    }
  };
  useEffect(() => {
    const searchEle = document.querySelector(".search-icon-mobile");
    const backEle = document.querySelector(".back_arrow");
    setZindex(searchEle);
    setZindex(backEle);
  }, [menuOpen,wishlistSidebarOpen,basketSidebarOpen,accountSidebarOpen, engraveSidebarOpen]);

  useEffect(() => {
    if(previous_nav && previous_nav != activeIcon && activeIcon == '/account' && !accountSidebarOpen) {
      setActiveIcon(previous_nav)
      setSelectedIcon(previous_nav);
      dispatch(previousNavSelect(''));
    }
  }, [previous_nav,accountSidebarOpen]);

  //OS-4181: Signing in/out of My account should re-open My account
  useEffect(() => {
    // Check if account reopen cookie is present which was set when clicked on Log in / Register CTA from My account 
    // or when clicked on signout 
    if (getCookie("account_reopen")) {
      // if user is logged in then open My account drawer(logged in state)
      // else open My account drawer(logged out state). setTimeout with 550 is added to override the timeout added in handleMobileAccountBar function which has timeout of 500 when value passed is false so that account drawer can be opened.
      userLoggedIn
        ? handleMobileAccountBar(true)
        : setTimeout(() => {
            dispatch(openAccountSidebar(true));
          }, 550);
      // to open PWA account drawer
      dispatch(openAccountSidebarFromPwaHeader(true));
      // to set account tab as active
      handleRoute("/account");
      //delete cookie which was added to re open account sidebar
      deleteCookie("account_reopen");
    }
  }, [userLoggedIn]);

  return (
    <div className={`${styles.footer_pwa_fixed} pwa_nav_fixed ${wc_journey_step !== 6 ?styles.wc_journey_active:""}`}>
      <div className={`container-fluid ${styles.no_padding} `}>
        <div className={`row ${styles.equally_spaced} `}>
          <div
            className={`grid-md-12 position_relative ${styles.equally_spaced} ${styles.navItems}`}
          >
            <div
              id="pwaHome"
              data-ga4={"App: Nav Bar - Home"}
              className={isActive("/") ? styles.is_active : `${styles.not_active}`}
              onClick={(e) => {
                e.preventDefault();
                dispatch(closeOliPopup());
                handleRoute("/");
              }}
            >
              <HomeIcon
                fill={"#2f2f30"}
                width="19px"
                height="18px"
                isPwa={checkPwa}
              />
              <div data-ga4={"App: Nav Bar - Home"}>Home</div>
            </div>
            <div
              id="pwaShop" className={isActive("/shop") ? styles.is_active : styles.not_active}
              data-ga4={"App: Nav Bar - Shop"}
              onClick={(e) => {
                e.preventDefault();
                dispatch(openEngraveSidebar(false));
                dispatch(lowerHeaderZIndex(false));
                dispatch(closeOliPopup());
                handleRoute("/shop");
              }}
            >
              <ShopAndSearch stroke={"#2f2f30"} width="27px" height="18px" isPwa={checkPwa}/>
              <div data-ga4={"App: Nav Bar - Shop"}>Shop</div>
            </div>
            <div
              id="pwaDesigner"
              data-ga4={"App: Nav Bar - Designers"}
              className={isActive("/designer") ? styles.is_active : `${styles.not_active}`}
              onClick={(e) => {
                e.preventDefault();
                handleRoute("/designer");
              }}
            >
              <DesignerIcon
                fill={"#2f2f30"}
                width="24px"
                height="16px"
                isPwa={checkPwa}
              />
              <div data-ga4={"App: Nav Bar - Designers"}>Designers</div>
            </div>
            <div
              id="pwaImpact"
              data-ga4={"App: Nav Bar - Impact"}
              className={isActive("/impact") ? styles.is_active : `${styles.not_active}`}
              onClick={(e) => {
                e.preventDefault();
                handleRoute("/impact");
              }}
            >
              <ImpactIcon
                fill={"#2f2f30"}
                width="22px"
                height="20px"
                isPwa={checkPwa}
              />
              <div data-ga4={"App: Nav Bar - Impact"}>Impact</div>
            </div>
            <div
              id="pwaAccount" className={isActive("/account") ? styles.is_active : styles.not_active}
              data-ga4={"App: Nav Bar - Account"}
              onClick={(e) => {
                e.preventDefault();
                dispatch(openEngraveSidebar(false));
                dispatch(lowerHeaderZIndex(false));
                handleMobileAccountBar(true);
                //  if user using PWA and not using it for the first time then setting guest state to false
                dispatch(isGuest(false))
                //This state is set to know that the account drawer was opened through PWA header when the user was not logged in.
                dispatch(openAccountSidebarFromPwaHeader(true));
                handleRoute("/account")
              }}
            >
              <AccountIcon
                stroke={"#2f2f30"}
                width="17px"
                height="22px"
                fill={userLoggedIn ? "" : "none"}
                isPwa={checkPwa}
              />
              <div data-ga4={"App: Nav Bar - Account"}>Account</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PWAHeader;
